/* eslint-disable */
import React from 'react';
import { ScanScreen } from '../_shared/ScanScreen';

const STEPS = ['proportions', 'faceShape', 'jawline', 'hairline', 'matching'];

function Page() {
  return (
    <ScanScreen
      page="hairstyle-women-analysis"
      ns="hairstyleWomenAnalysis"
      stepKeys={STEPS}
      durationMs={14000}
    />
  );
}

export default Page;
